import "./CertificateGroupingWIthRating.scss";
import CertificateWithRating from "../../features/ServiceCertificateGrouping/CaseOfficerReviewForm/CertificateWithRating/CertificateWithRating"

const CertificateGroupingWIthRating = () => {
  return (
    <div className="analytics-page">
      <CertificateWithRating />
    </div>
  );
};

export default CertificateGroupingWIthRating;
